import { boundsTooBig } from "./bbox"

export const WATER_MAP_WATER_LAYERS = Object.freeze(["rivers", "lakes"])

export function layerMaxDegrees(layerLimits, key) {
  const limit = Number(layerLimits?.[key])
  return Number.isFinite(limit) && limit > 0 ? limit : Infinity
}

export function waterLayerTooBig(bounds, layerLimits, key) {
  return boundsTooBig(bounds, layerMaxDegrees(layerLimits, key))
}

export function zoomInLayerMessage(keys) {
  if (!keys.length) return ""
  return `Zoom in for ${keys.join(" & ")}`
}
